import api from '@services/api'

export default {
  get(axios, params, query, config) {
    return api.get(axios, '/account/address', params, query, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/account/address', params, payload, config)
  },
}
